import type { UserId } from '#shared/types/users'
import type { NullableBoolean } from '~/types/utils'

export enum AuthStatus {
  AUTHORIZED = 'AUTHORIZED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAUTHORIZED_WITH_ERROR = 'UNAUTHORIZED_WITH_ERROR',
  UNAUTHORIZED_TOKEN_REFRESH = 'UNAUTHORIZED_TOKEN_REFRESH',
  LOGGING_OUT = 'LOGGING_OUT'
}

export type RoleType =
  | 'cook'
  | 'foodie'
  | 'admin'
  | 'matchmaker'
  | 'ex_matchmaker'
  | 'developer'
  | 'finance'
  | 'reporting'
  | 'migrated'

export interface Role {
  role: RoleType
  param: string | null
}

export interface Token {
  userId: UserId
  email: string
  accessToken: string
  tokenType: string
  expiresIn: number
  isFocusMunicipality: NullableBoolean
}

export interface LoginParams {
  email: string
  password: string
  rememberMe: boolean
}

export interface RequestPasswordResetParams {
  email: string
}

export interface PasswordResetParams {
  token: string
  email: string
  password: string
}

export interface PasswordChangeParams {
  oldPassword: string
  newPassword: string
}
